export const mutations = {
  setProductDetails (state, { key, data }) {
    state.cache = Object.assign({}, state.cache, { [key]: data })
  }
}
